import { z } from 'zod';
import {
  BaseResponseSchema,
  uuidSchema,
} from './primitives.js';

export const TenantSpatialCapabilitiesSchema = z.object({
  /** UI hint for optional source-filter chips; does not filter read APIs. */
  positionSourceFilter: z.enum(['vendor', 'uwb', 'all']).nullable(),
});

export const TenantJobCapabilitiesSchema = z.object({
  creatableTypes: z.array(z.enum(['container_slot_scan', 'batch_wafer_transfer'])),
});

export const TenantRouteCapabilitiesSchema = z.object({
  spatialOverview: z.boolean(),
  nodeCommandCenter: z.boolean(),
  nodeFleetHealth: z.boolean(),
  satelliteHealth: z.boolean(),
  cleanroomLayout: z.boolean(),
  axonSetup: z.boolean(),
  scanTemplates: z.boolean(),
  waferIdAcquire: z.boolean(),
  waferDataRefresh: z.boolean(),
  audits: z.boolean(),
  conflictResolution: z.boolean(),
});

export const TenantCapabilitiesResponseSchema = BaseResponseSchema.extend({
  data: z.object({
    modules: z.record(z.boolean()),
    spatial: TenantSpatialCapabilitiesSchema,
    jobs: TenantJobCapabilitiesSchema,
    routes: TenantRouteCapabilitiesSchema,
  }),
});



export const InternalTenantEntitlementsResponseSchema = BaseResponseSchema.extend({
  data: z.object({
    tenantId: uuidSchema,
    modules: z.record(z.boolean()),
    spatialPositionSourceFilter: z.enum(['vendor', 'uwb', 'all']).nullable(),
  }),
});
// Inferred types
export type InternalTenantEntitlementsResponse = z.infer<
  typeof InternalTenantEntitlementsResponseSchema
>;
export type TenantCapabilitiesResponse = z.infer<typeof TenantCapabilitiesResponseSchema>;
export type TenantJobCapabilities = z.infer<typeof TenantJobCapabilitiesSchema>;
export type TenantSpatialCapabilities = z.infer<typeof TenantSpatialCapabilitiesSchema>;
